import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=caaac818&scoped=true&"
import script from "./ChatModal.vue?vue&type=script&lang=js&"
export * from "./ChatModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatModal.vue?vue&type=style&index=0&id=caaac818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaac818",
  null
  
)

export default component.exports